/**
 * Manages recently viewed products in localStorage.
 * Stores only the product id; card markup is rendered server-side from live search results.
 */
export class RecentlyViewed {
  static #STORAGE_KEY = 'rv_products';
  static #MAX_ITEMS = 10;

  /**
   * Records a product view. Stores only the product id in localStorage.
   * @param {object} product - { id }
   */
  static addProduct(product) {
    try {
      let viewed = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
      viewed = viewed.filter((p) => p.id !== product.id);
      viewed.unshift(product);
      viewed = viewed.slice(0, this.#MAX_ITEMS);
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewed));
    } catch { /* quota exceeded or parse error – silently ignore */ }
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Returns all recently viewed products.
   * @returns {Array<{id: number}>}
   */
  static getProducts() {
    try {
      return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
    } catch {
      return [];
    }
  }
}
